module.exports = __webpack_public_path__ + "img/delete.067fd9a8.svg";